import StoreContext from "contexts/StoreContext";
import React, { useState, useEffect, useContext } from "react";
import { Card, Table } from "react-bootstrap";
import { apiService } from "service/ApiService";
import { notificationService } from "service/NotificationService";
import { serverTimesampToNormalDate } from "utils/AppUtils";
import { ClipLoader } from "react-spinners";

import { useTranslation } from "react-i18next";

function TableProductsTable({ tableId, tableName }) {
  const {
    t,
  } = useTranslation();

  const [data, setData] = useState([]);
  const [subtotal, setSubTotal] = useState(0);
  const [quantity, setQuantity] = useState(0);
  const [total, setTotal] = useState(0);
  const [discount, setDiscount] = useState(0);
  const [showLoader, setShowLoader] = useState(true);
  const { storeId, setStoreId } = useContext(StoreContext);

  const getData = async () => {
    setShowLoader(true);
    try {
      const dataResponse = await apiService.get(`api/v1/tables/${tableId}/store/${storeId}/open`);
      const sumSubtotal = _.sumBy(dataResponse, "subTotal");
      const sumDiscount = _.sumBy(dataResponse, "discount");
      const sumTotal = _.sumBy(dataResponse, "total");
      const sumQuantity = _.sumBy(dataResponse, "quantity");

      setSubTotal(sumSubtotal);
      setQuantity(sumQuantity);
      setTotal(sumTotal);
      setDiscount(sumDiscount);
      setData(dataResponse);
    } catch (error) {
      console.error("Error fetching data:", error);
      notificationService.notifyWarn(error.message);
    } finally {
      setShowLoader(false);
    }
  };

  useEffect(() => {
    if (!tableId) return;
    getData();
  }, [tableId]);

  return (
    <Card className="regular-table-with-color">
      <Card.Header as="h5" className="text-center">
        {t("common.labels.tableSuffix") + tableName}
      </Card.Header>
      <Card.Body className="table-responsive p-0">
        {showLoader ? (
          <div style={{ textAlign: "center", marginTop: "5vh", marginBottom: "5vh" }}>
            <ClipLoader size={50} color={"#ff6fbc"} />
          </div>
        ) : (
          <Table className="table-hover">
            <thead>
              <tr>
                <th>{t("tables.headers.date")}</th>
                <th>{t("tables.headers.product")}</th>
                <th>{t("tables.headers.quantity")}</th>
                <th>{t("tables.headers.totalEuro")}</th>
              </tr>
            </thead>
            <tbody>
              {data.map((row, index) => (
                <tr key={index}>
                  <td className="font-weight-normal">
                    <div>{serverTimesampToNormalDate(row.localCreatedAt)}</div>
                    <div>{row.order.storeUser.name}</div>
                  </td>
                  <td className="font-weight-normal">
                    {row.product.name}
                    {row.extra.length > 0 ? (
                      <div style={{ fontSize: "12px" }}>
                        {row.extra
                          .map((extra) =>
                            extra.extraPrefix ? extra.extraPrefix.extra_prefix_name + " " + extra.extra.extra_name : extra.extra.extra_name
                          )
                          .join(", ")}
                      </div>
                    ) : null}

                    {row.comments.length > 0 ? <div style={{ fontSize: "12px", marginTop: "0px" }}>{row.comments}</div> : null}
                  </td>
                  <td className="font-weight-normal">{row.quantity}</td>

                  <td className="font-weight-normal">
                    <span className="text-danger">
                      <del>{row.discount > 0 ? row.subTotal.toFixed(2) : null}</del>
                    </span>
                    &nbsp;&nbsp;&nbsp;
                    <span className="font-weight-normal">{row.total.toFixed(2)}</span>
                  </td>
                </tr>
              ))}
              <tr key="last">
                <td className="font-weight-bold"></td>
                <td className="font-weight-bold">{t("tables.headers.total")}</td>
                <td className="font-weight-bold">{quantity}</td>

                <td className="font-weight-bold">
                  <span className="text-danger">
                    <del>{discount > 0 ? subtotal.toFixed(2) : null}</del>
                  </span>
                  &nbsp;&nbsp;&nbsp;
                  <span className="font-weight-bold">{total.toFixed(2)}</span>
                </td>
              </tr>
            </tbody>
          </Table>
        )}
      </Card.Body>
    </Card>
  );
}

export default TableProductsTable;
